export function isNode(node) {
  return node && node.isNode;
}